// extracted by mini-css-extract-plugin
module.exports = {"root":"ConsentHeader_root__2Go33","name":"ConsentHeader_name__GSga0","birthday":"ConsentHeader_birthday__38-2L","skeleton":"ConsentHeader_skeleton__39sQH"};